import './styles.css';
import SvgIcon, { iconList } from "../iconSVG";
function ModalContainer({
  show,
  hidden,
  sizeWidth,
  sizeHeight,
  children,
  hiddenButton = false
}) {
  return (
    <div className={`modalContainer ${show ? 'modalContainerShow' : 'modalContainerHidden'}`}>
      {!hiddenButton &&
        <div className='modalContainerBtn'
          onClick={() => hidden(!show)}
        >
          <SvgIcon color={'#FFF'} name={iconList.IconCloseCircleOutLine} size={30} />
        </div>
      }
      <div
        className='cardContainer'
        style={{
          width: `${sizeWidth}%`,
          height: `${sizeHeight}%`,
        }}>
        {children}
      </div>
    </div>
  )
}

export default ModalContainer;